// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"696":"e57c666f","834":"b87fcd15","976":"db63c64e"}[chunkId] + ".chunk.js";
};